"use client";

import { useEffect } from "react";
import { initializeDatadog } from "@/services/datadog.service";

export function DatadogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Datadog on mount (client-side only)
    initializeDatadog();
  }, []);

  return <>{children}</>;
}
